import { Injectable } from '@angular/core';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';

@Injectable({
  providedIn: 'root'
})
export class SubmittedAppsService {

  constructor(
    private httpClient: HTTPWrapperContext
  ) { }
  //comment for code placeholder story for submitted app page updates
  downloadSubmissionLog(fileId: string): Promise<any> {
    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: '/sxesvc/api/v3/bulk-enrollment/download',
      strategyConfigs: { forceModernUrl: true },
      GET_PAYLOAD: {
        fileid: fileId,
        type: "ORIGINAL"
      }
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);
  }

  getSuccessSummary(fileId: string) {
    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: '/sxesvc/api/v3/bulk-enrollment/submittedApps',
      strategyConfigs: { forceModernUrl: true },
      GET_PAYLOAD: {
        fileid: fileId
      }
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);
  }


}
